<template>
  <div id="contact-modal">
      <v-dialog v-model="dialog" persistent max-width="600px">

        <template v-slot:activator="{ on }">
          <v-fab-transition>
              <v-btn
                color="#1976d2"
                dark
                fab
                fixed
                bottom
                right 
                @click.stop="dialog = true"
              >
              <v-icon>fas fa-envelope</v-icon>
            </v-btn>
          </v-fab-transition>
        </template>

        <v-card>
          <v-card-title>
            <span class="headline">Need Help? Let Us Know!</span>
          </v-card-title>

          <v-card-text>
              <ContactForm />
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
            <!-- <v-btn color="blue darken-1" flat @click="dialog = false">Submit</v-btn> -->
          </v-card-actions>

        </v-card>
        
      </v-dialog>
    </div>
</template>

<script>
import ContactForm from '../ContactForm';

export default {
  name: 'contact-modal',
    data: () => ({
        dialog: false
    }),
    components: {
        ContactForm
    }
}
</script>

<style scoped>

</style>